import { DefaultFooter } from '@ant-design/pro-components';
import { useIntl } from '@umijs/max';
import { getBrandFooterCopyright } from 'config/brand';
import React from 'react';

const Footer: React.FC = () => {
  const intl = useIntl();

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={getBrandFooterCopyright(intl.locale)}
    />
  );
};

export default Footer;
